import { SET_SELECTED_FAVOURITE } from '../../@types/action.types'

const doFavouriteReducers = {
    [SET_SELECTED_FAVOURITE]: (state, { payload }) => {
        state.selectedProduct = payload
    }
}

export default doFavouriteReducers
